import { faqAnchorId, type Faq } from "@/components/site/InsuranceProse";

/**
 * Visible FAQ block for procedure pages. Pair with `faqSchema(faqs, url)`
 * in the route `head()` so the markup and the FAQPage JSON-LD always match.
 */
export function ProcedureFaq({ heading, faqs }: { heading: string; faqs: Faq[] }) {
  return (
    <section aria-labelledby="procedure-faq">
      <h2
        id="procedure-faq"
        className="mt-8 text-[1.35rem] md:text-[1.6875rem] font-serif"
      >
        {heading}
      </h2>
      {faqs.map((f) => (
        <div key={f.q} id={faqAnchorId(f.q)} className="scroll-mt-24">
          <h3 className="mt-3 font-semibold text-foreground">{f.q}</h3>
          <div className="mt-1 text-foreground/80">{f.a}</div>
        </div>
      ))}
    </section>
  );
}
